<template>
    <v-list-group
        color="neutral-1"
        :prepend-icon="menu.icon"
    >
        <template v-slot:activator>
            <v-list-item-title v-text="menu.name"></v-list-item-title>
        </template>

        <template v-for="(child, id) in menu.children" >
            <category-menu-child v-if="child.children" :menu="child" :key="menu.name + id" />
            <category-menu-item v-else :menu="child" :key="menu.name + id" />
        </template>
    </v-list-group>
</template>

<script>
import CategoryMenuChild from './CategoryMenuChild';
import CategoryMenuItem from './CategoryMenuItem';

export default {
    components: {
        CategoryMenuChild,
        CategoryMenuItem,
    },
    props: {
        menu: {
            required: true,
            type: Object,
        },
    },
};
</script>
